import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { productsJswGuestAccessRoute } from '@atlassian/jira-router-routes-products-jsw-configuration-routes/src/productsJswGuestAccessRoute.tsx';
import guestAccessPageEntrypoint from './ui/products-jsw-guest-access/index.tsx';

export const productsJswGuestAccessRouteEntry = createEntry(productsJswGuestAccessRoute, () => ({
	group: 'global-settings',
	ufoName: 'admin.jsw-configuration.guest-access',
	entryPoint: () => guestAccessPageEntrypoint,
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
		menuId: MENU_ID.SETTINGS,
		sidebar: AsyncSidebarGlobalSettingsProducts,
	},

	resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

	forPaint: [LazyAtlassianNavigation],

	bifrost: {
		bifrostGroup: 'shell-only',
		bundling: {
			packageName:
				'@atlassian/jira-router-routes-products-jsw-configuration-entries/src/productsJswGuestAccessRouteEntry.tsx',
			whichExportToUse: 'productsJswGuestAccessRouteEntry',
		},
		enabled: true,
	},
}));
